import { useEffect, useState } from "react";
import { usePagination } from "../usePagination";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { timetoUTC } from "../../helper/functions";
import { $crud } from "../../utils/CrudFactory";

export default function useOrders() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [newPosition, setNewPosition] = useState(""); // state to open position modal
  const [positionModalOpen, setPositionModalOpen] = useState(false); // state to open position modal
  const [positionPlaceholder, setPositionPlaceholder] = useState(""); // state to open position modal
  const [positionBtn, setPositionBtn] = useState(""); // state to open position modal
  const [positionModalTitle, setPositionModalTitle] = useState(""); //state to display position modal title
  const [selectedRow, setSelectedRow] = useState(null); // To store the selected row for which position is being updated
  const [rows, setRows] = useState([]); //STATE TO GET THE ORDER LIST
  const { page, limit, setLimit, setPage, total, setTotal } = usePagination(); // PAGINATION PROPS
  const [searchInput, setSearchInput] = useState("");
  const [isFilter, setIsFilter] = useState(false); //STATE TO GET THE ORDER LIST
  const queryParams = new URLSearchParams(location.search);
  const driverId = queryParams.get("driverId");
  const clientId = queryParams.get("clientId");
  const [isSorting, setIsSorting] = useState(false);

  const [filtrationData, setFiltrationData] = useState({
    orderType: "",
    orderStatus: "",
    position: "",
    search: driverId || clientId || "",
    from: "",
    to: "",
    amountFrom: "",
    amountTo: "",
  });

  useEffect(() => {
    if (driverId) {
      setSearchInput(driverId);
    }
    if (clientId) {
      setSearchInput(clientId);
    }
  }, [driverId, clientId]);

  const isFilterenabled = [
    filtrationData.amountFrom,
    filtrationData.amountTo,
    filtrationData.from,
    filtrationData.to,
    filtrationData.orderStatus,
    filtrationData.orderType,
    filtrationData.position,
    filtrationData.search,
  ].some((val) => !!val);

  async function retrieveData() {
    const isFilterApplied = Object.values(filtrationData).some(
      (value) => value !== "" && value !== false
    );

    const params = {
      search: filtrationData.search,
      position: filtrationData.position,
      orderType: filtrationData.orderType,
      orderStatus: filtrationData.orderStatus,
      from: filtrationData.from,
      to: filtrationData.to,
      amountFrom: filtrationData.amountFrom,
      amountTo: filtrationData.amountTo,
      skip: rows.length,
    };

    if (!isFilterApplied) {
      params.limit = 0;
      params.page = 0;
    }

    const { data } = await $crud.retrieve("admin/orders", params);
    return data;
  }

  useEffect(() => {
    retrieveData().then((res) => {
      setRows(res.result);
      setTotal(res.total);
    });
  }, [limit, page, filtrationData]);

  const handlePositionChange = (row, newPosition) => {
    setSelectedRow(row);
    setNewPosition(newPosition);
    switch (newPosition) {
      case "Reject":
        setPositionModalTitle("Reason For Rejection");
        setPositionPlaceholder("Enter Reason For Rejection here");
        setPositionBtn("Reject");
        break;
      case "Review":
        setPositionModalTitle("Reason For Review");
        setPositionPlaceholder("Enter Reason For Review here");
        setPositionBtn("Review");
        break;
      case "No Holds":
        setPositionModalTitle("Reject Resolution Comments");
        setPositionPlaceholder("Enter Comments For Reject Resolution");
        setPositionBtn("No Holds");
        break;
      default:
        setPositionModalTitle("");
        break;
    }
    setPositionModalOpen(true);
  };

  const handleCloseModal = () => {
    setPositionModalTitle(false);
    setSelectedRow(null);
    setPositionModalOpen("");
  };

  const handlePositionSubmit = async (reason) => {
    try {
      const { data, type } = await $crud.put(`admin/order`, {
        position: newPosition,
        comment: reason,
        _id: selectedRow._id,
      });
      if (type == "success") {
        retrieveData().then((res) => {
          setRows(res.result);
          setTotal(res.total);
        });
      }
      handleCloseModal();
    } catch (e) {
      console.error(e);
    }
  };

  const getActiveStatus = (statuses) => {
    return statuses.find((status) => status.active)?.status || "";
  };

  const handleSearchInputChange = (value) => {
    setSearchInput(value);
    setFiltrationData((prevData) => ({
      ...prevData,
      search: value,
    }));
  };


  return {
    theme,
    handleCloseModal,
    handlePositionChange,
    handlePositionSubmit,
    handleSearchInputChange,
    navigate,
    searchInput,
    selectedRow,
    setFiltrationData,
    filtrationData,
    setIsFilter,
    setIsSorting,
    rows,
    setRows,
    positionPlaceholder,
    positionBtn,
    setPage,
    positionModalOpen,
    positionModalTitle,
    total,
    retrieveData,
    isFilterenabled,
    setTotal,
  };
}
